import { render } from "./GlobalForm.vue?vue&type=template&id=225d849a"
import script from "./GlobalForm.vue?vue&type=script&lang=js"
export * from "./GlobalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__